export default "__VITE_ASSET__bd42c285__"